
import { HttpClientModule } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  computed,
  inject
} from '@angular/core';
import Map from '@arcgis/core/Map';
import { EsriViewType, LayerResults, ViewConfig } from '@jeppesen-foreflight/jmkw-types';
import { NGXLogger } from 'ngx-logger';
import { BasemapSelectorComponent } from '../../../components/basemap-selector/basemap-selector.component';
import { store } from '../../../jmkw.store';
import { ArcgisService } from '../arcgis.service';

@Component({
  selector: 'jmkw-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
  imports: [HttpClientModule, BasemapSelectorComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapViewComponent {
  private readonly _logger = inject(NGXLogger);
  private readonly _arcgisService = inject(ArcgisService);
  show2d = computed(() => store.views['2D'].visible());
  show3d = computed(() => store.views['3D'].visible());

  @Output() mapLoaded = new EventEmitter<Map>();
  @Output() layersLoaded = new EventEmitter<LayerResults>();
  @Output() viewsLoaded = new EventEmitter<Record<EsriViewType, ViewConfig>>();

  constructor() {
    this.init();
  }

  @ViewChild('view2d', { static: false }) private set _view2dElement(
    el: ElementRef
  ) {
    this._arcgisService.toggleViewContainer(el, '2D');
  }
  @ViewChild('view3d', { static: false }) private set _view3dElement(
    el: ElementRef
  ) {
    this._arcgisService.toggleViewContainer(el, '3D');
  }

  init() {
    this._arcgisService.mapLoaded$.subscribe((results) => {
      this._logger.trace('[MapViewComponent] mapLoaded', results);
      store.state.mapLoaded.set(true);
      this.mapLoaded.emit(results);
    });
    this._arcgisService.layersLoaded$?.subscribe((results) => {
      this._logger.trace('[MapViewComponent] layersLoaded', results);
      store.state.layersLoaded.set(true);
      this.layersLoaded.emit(results);
    });
    this._arcgisService.viewsLoaded$.subscribe((results) => {
      this._logger.trace('[MapViewComponent] viewsLoaded', results);
      store.state.viewsLoaded.set(true);
      this.viewsLoaded.emit(results);
    });
  }
}
